import * as React from 'react';

export const DislikeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 2L4.00003 11.126L8.32166 15.5537C8.55476 15.8362 8.90363 16 9.27303 16H9.55376C10.2318 16 10.7816 15.4579 10.7816 14.7895V11.5485H14.5615C15.3561 11.5485 16 10.9133 16 10.1304C16 8.30882 14.6913 4.94822 13.9412 3.17167C13.6376 2.45274 12.9288 2 12.1484 2H4ZM3 11H0V2H3V11Z" fill="#152242" fill-opacity="0.4"/>
  </svg>
);
